/* eslint-disable @typescript-eslint/no-explicit-any -- Angular uses many "any" defaults, so we do too. */
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- We're extending Angular's native FormGroup here.
import {AbstractControl, FormGroup} from '@angular/forms';
import {AngularAsyncValidator, ExtendedAbstractControl} from '@aviary/forms/extensions/form-extensions.types';
import {AsyncValidatorRemoverResult, removeAsyncValidatorsFrom} from '@aviary/forms/extensions/form-extensions.helpers';

export class ExtendedFormGroup<
  T extends { [K in keyof T]: ExtendedAbstractControl } = any
> extends FormGroup<T> implements ExtendedAbstractControl {

  public get extendedControls(): { [K in keyof T]: T[K] } {
    // eslint-disable-next-line no-restricted-syntax -- We're using this.controls to create this extended getter that replaces it.
    return this.controls as { [K in keyof T]: T[K] };
  }

  public get invalidOrPending(): boolean {
    return super.invalid || super.pending;
  }

  // Add a type-safe get() that returns the actual control type:
  public override get(path: string | (string | number)[]): AbstractControl | null;
  public override get<K extends keyof T>(controlName: K): T[K] | null;
  public override get(pathOrKey: any): any {
    return super.get(pathOrKey);
  }

  public shouldRender: boolean = true;
  public readonly uuid: string = crypto.randomUUID();
  public readonly initialLength: number;

  constructor(controls: { [K in keyof T]: T[K] }, validatorOrOpts?: any, asyncValidator?: AngularAsyncValidator | null) {
    const {validatorOrOptsWithoutAsyncValidators, addRemovedAsyncValidatorsTo}: AsyncValidatorRemoverResult =
      removeAsyncValidatorsFrom(validatorOrOpts, asyncValidator);

    super(controls, validatorOrOptsWithoutAsyncValidators);

    this.initialLength = Object.keys(controls).length;

    addRemovedAsyncValidatorsTo(this);
  }
}
